<template>
  <div class="records-card">
    <img
      :src="headImg"
      class="records-img" />
    <div class="records-content">
      <div class="records-title">
        <div class="title-phone">{{ phone }}</div>
        <div class="title-info"><template v-if="showDays">{{ message }} · </template>{{ vehicle }}</div>
      </div>
      <div class="records-progress">
        <!-- 未激活 -->
        <template v-if="+status === NON_ACTIVATED">
          <div class="records-nonactivated">{{ description }}</div>
        </template>
        <!-- 进行中或成功 -->
        <!-- 单量阶梯的非阶梯奖励 or 人数阶梯奖励 -->
        <template  v-else-if="isSingleProgress">
          <div class="records-orders">
            <div v-if="+status === SUCCESS_AMOUNT_PUSH || +status === SUCCESS_AMOUNT_PENDING" class="records-success">{{ statusDesc }}</div>
            <div v-else><span class="current-orders">{{ currentOrder }}</span><span class="separator">/</span><span class="total-orders">{{  maxNumber }} {{ $t('FoodD_2_Single_amount_LbPB'/** 单量 */) }}</span></div>
            <div v-if="isOrder" class="award-num">{{ maxAmount }}</div>
          </div>
          <rich-progress :value="currentOrder/maxNumber.toFixed(0) * 100" class="records-bar"></rich-progress>
        </template>
        <!-- 单量奖励的阶梯奖励 -->
        <template v-else-if="isMultiProgress">
          <div v-if="+status === SUCCESS_AMOUNT_PUSH || +status === SUCCESS_AMOUNT_PENDING" class="records-success">{{ statusDesc }}</div>
          <rich-progress
            :params="multiProgressParams"
            :current="currentOrder"
            :content="progressHead"
            :is-subsection="true"
            class="progress-overlay"></rich-progress>
        </template>
        <!-- 失败 -->
        <template v-else-if="+status === FAIL_NOT_COMPLETE || +status === FAIL_NOT_ACTIVE">
          <div class="records-failed">
            <div class="failed-title">{{ statusDesc || subtext }}</div>
            <div class="failed-subscribe">{{ description || message }}</div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
/** 未激活 */
const NON_ACTIVATED = 4;
/** 进行中 */
const IN_PROGRESS = 3;
/** 成功 2 */
const SUCCESS_AMOUNT_PUSH = 2;
/** 成功 1 */
const SUCCESS_AMOUNT_PENDING = 1;
/** 失败 6 */
const FAIL_NOT_ACTIVE = 6;
/** 失败 5 */
const FAIL_NOT_COMPLETE = 5;

/** 单量阶梯 */
const IS_ORDER = 1
export default {
  name: 'RecordsCard',
  props: {
    record: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      NON_ACTIVATED,
      SUCCESS_AMOUNT_PUSH,
      SUCCESS_AMOUNT_PENDING,
      FAIL_NOT_COMPLETE,
      FAIL_NOT_ACTIVE
    }
  },
  computed: {
    headImg () {
      const { record: {headImg} = {} } = this
      return headImg || ''
    },
    phone () {
      const { record: {phone} = {}} = this
      return phone || ''
    },
    vehicle () {
      const { record: {initVehicleType} = {}} = this
      return initVehicleType || ''
    },
    status () {
      const { record: {status} = {}} = this
      return status || 0
    },
    message () {
      const { record: {message} = {}} = this
      return message || ''
    },
    progressBar () {
      const { record: {progressBar} = {}} = this
      return progressBar || {}
    },
    // 是否为单量阶梯
    isOrder () {
      const { record: {displayType} = {} } = this
      return+displayType === IS_ORDER
    },
    // 状态进行中或成功
    // (单量阶梯 且 单奖励梯度) 或 人数阶梯
    isSingleProgress () {
      const { status, record: {displayType, levelCount} = {} } = this
      return (+status === SUCCESS_AMOUNT_PUSH || +status === SUCCESS_AMOUNT_PENDING || +status === IN_PROGRESS) && (+displayType === IS_ORDER && +levelCount <= 1 || +displayType !== IS_ORDER)
    },
    // 状态进行中或成功
    // 单量阶梯 且 多奖励梯度
    isMultiProgress () {
      const { status, record: {displayType, levelCount} = {} } = this
      return (+status === SUCCESS_AMOUNT_PUSH || +status === SUCCESS_AMOUNT_PENDING || +status === IN_PROGRESS) && (+displayType === IS_ORDER && +levelCount > 1)
    },
    multiProgressParams () {
      const { progressBar: {levels = {}} = {} } = this
      return Object.keys(levels).map(key => {
        let level = levels[key]
        return {
          detail: level.top + '',
          mainTitle: level.bottom + '',
          inProgress: level.finish,
          value: +level.bottom
        }
      })
    },
    progressHead () {
      const { progressBar: {head} = {} } = this
      return head || {}
    },
    currentOrder () {
      const { progressBar: {currentNumber} = {} } = this
      return currentNumber || 0
    },
    maxNumber () {
      const { progressBar: {maxNumber} = {} } = this
      return maxNumber || 0
    },
    maxAmount () {
      const { progressBar: {maxAmountDisplay} = {} } = this
      return maxAmountDisplay || ''
    },
    statusDesc () {
      const { record: {statusDesc} = {}} = this
      return statusDesc || ''
    },
    description () {
      const { record: {description} = {}} = this
      return description || ''
    },
    subtext () {
      const { record: {subtext} = {}} = this
      return subtext || ''
    },
    showDays () {
      const { status } = this
      return +status === IN_PROGRESS || +status === NON_ACTIVATED
    }
  }

}
</script>

<style lang='stylus' scoped>
.records-card {
  display: flex;
  padding-bottom: 40px;
  .records-img {
    width: 64px;
    height: 64px;
    border-radius: 16px;
  }
  .records-content {
    flex: 1 1 auto;
    margin-left: 16px;
  }
  .records-title {
    .title-phone {
      font-family: DiDiSans-Pro-Medium;
      font-size: 28px;
      color: #000;
      letter-spacing: 0;
      line-height: 28px;
    }
    .title-info {
      font-family: DiDiSans-Pro-Regular;
      font-size: 24px;
      color: rgba(0, 0, 0, .5);
      letter-spacing: 0;
      line-height: 24px;
      margin-top: 8px;
    }
  }
  .records-progress {
    width: 526px;
    margin-top: 40px;
    overflow: hidden;
  }
}

.records-orders {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: DiDiSans-Pro-Regular;
  font-size: 24px;
  color: #000000;
  line-height: 24px;

  .current-orders {
    font-family: DiDiSans-Pro-Medium;
  }
  .separator {
    font-family: DiDiSans-Pro-Medium;
    font-size: 18px;
    padding-left: 3px;
  }
  .total-orders {
    font-family: DiDiSans-Pro-Medium;
    font-size: 24px;
  }
  .award-num {
    font-family: DiDiSans-Pro-Bold;
  }
}
.records-bar {
  ::v-deep .rich-progress-horizontal {
    display: none;
  }
}
.records-nonactivated {
  font-family: DiDiSans-Pro-Bold;
  font-size: 28px;
  color: #000;
  letter-spacing: 0;
  line-height: 30px;
}
.records-failed {
  .failed-title {
    font-family: DiDiSans-Pro-Bold;
    font-size: 28px;
    color: #ff4060;
    text-align: left;
    line-height: 28px;
    margin-bottom: 8px;
  }
  .failed-subscribe {
    font-family: DiDiSans-Pro-Regular;
    font-size: 24px;
    color: #FF4060;
    letter-spacing: 0;
    line-height: 30px;
    font-weight: 400;
  }
}

.records-success {
  font-family: DiDiSans-Pro-Medium;
  font-size: 24px;
  color: #000;
  text-align: left;
  line-height: 24px;
  margin-bottom: 8px;
}
::v-deep .rich-progress-end {
  margin-left: 0;
}
::v-deep .rich-progress-horizontal {
  .scroll-panel {
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
.progress-overlay {
  ::v-deep .scroll-panel {
    padding-bottom: 0 !important;
  }
}
</style>